import { TRESPONSE_PLANI8_EMPLOYEE_LIST, TRESPONSE_TEAM_LIST } from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TEmployeeListState = {
  employeeListingInfo: TRESPONSE_PLANI8_EMPLOYEE_LIST | null;
  teamListingInfo: TRESPONSE_TEAM_LIST | null;
  userPaginationOption: TUserPaginationOption;
};

export const TEmployeeListInfoActionType = {
  GetEmployeeList: 'GET_EMPLOYEE_LIST' as const,
  GetEmployeeListSuccess: 'GET_EMPLOYEE_LIST_SUCCESS' as const,
  GetEmployeeListFailure: 'GET_EMPLOYEE_LIST_FAILURE' as const,
  UpdateEmployee: 'UPDATE_EMPLOYEE' as const,
  UpdateEmployeeSuccess: 'UPDATE_EMPLOYEE_SUCCESS' as const,
  UpdateEmployeeFailure: 'UPDATE_EMPLOYEE_FAILURE' as const,
  GetTeamList: 'GET_TEAM_LIST' as const,
  GetTeamListSuccess: 'GET_TEAM_LIST_SUCCESS' as const,
  GetTeamListFailure: 'GET_TEAM_LIST_FAILURE' as const,
  UpdateTeams: 'UPDATE_TEAM' as const,
  UpdateTeamsSuccess: 'UPDATE_TEAM_SUCCESS' as const,
  UpdateTeamsFailure: 'UPDATE_TEAM_FAILURE' as const,
  DeleteTeams: 'DELETE_TEAMS' as const,
  DeleteTeamsSuccess: 'DELETE_TEAMS_SUCCESS' as const,
  DeleteTeamsFailure: 'DELETE_TEAMS_FAILURE' as const,
  SetUserPaginationOption: 'SET_EMPLOYEE_LIST_USER_PAGINATION_OPTION' as const,
};
